import { createId } from 'tracking/eventIds';

export const RISK_PLAN_EXPERIMENT_KEY = 'risk_plan_visual_ab_v1';

const STORAGE_KEY = `cxnft_funnel_experiment_${RISK_PLAN_EXPERIMENT_KEY}`;
const STORAGE_VERSION = 2;
const PROMOTED_VARIANT = 'treatment';
const PROMOTED_VISUAL_FUNNEL = 'risk_invalidation';
const PROMOTED_ASSIGNMENT_SOURCE = 'promoted_winner';

function hasWindow() {
  return typeof window !== 'undefined';
}

function safeLocalStorage() {
  if (!hasWindow()) {
    return null;
  }

  try {
    return window.localStorage;
  } catch (error) {
    return null;
  }
}

function parseStoredAssignment(rawValue) {
  if (!rawValue) {
    return null;
  }

  try {
    const parsed = JSON.parse(rawValue);
    if (
      parsed?.version === STORAGE_VERSION &&
      parsed?.experiment_key === RISK_PLAN_EXPERIMENT_KEY &&
      parsed?.experiment_variant === PROMOTED_VARIANT &&
      typeof parsed?.assignment_id === 'string' &&
      typeof parsed?.assignment_created_at === 'string'
    ) {
      return parsed;
    }
  } catch (error) {
    return null;
  }

  return null;
}

function readStoredAssignment() {
  const storage = safeLocalStorage();
  if (!storage) {
    return null;
  }

  try {
    return parseStoredAssignment(storage.getItem(STORAGE_KEY));
  } catch (error) {
    return null;
  }
}

function writeStoredAssignment(assignment) {
  const storage = safeLocalStorage();
  if (!storage) {
    return;
  }

  try {
    storage.setItem(STORAGE_KEY, JSON.stringify(assignment));
  } catch (error) {
    // Experiment assignment should never block the funnel render.
  }
}

function buildPromotedAssignment({ assignmentSource, createdAt, assignmentId }) {
  return {
    version: STORAGE_VERSION,
    experiment_key: RISK_PLAN_EXPERIMENT_KEY,
    experiment_variant: PROMOTED_VARIANT,
    assigned_visual_funnel: PROMOTED_VISUAL_FUNNEL,
    assignment_id: assignmentId,
    assignment_source: assignmentSource,
    assignment_created_at: createdAt,
  };
}

export function resolveRiskPlanExperimentAssignment({ variant }) {
  if (variant?.key !== 'risk_plan') {
    return null;
  }

  const stored = readStoredAssignment();
  if (stored) {
    return {
      ...stored,
      experiment_variant: PROMOTED_VARIANT,
      assigned_visual_funnel: PROMOTED_VISUAL_FUNNEL,
      assignment_source: 'stored',
    };
  }

  const created = buildPromotedAssignment({
    assignmentSource: PROMOTED_ASSIGNMENT_SOURCE,
    createdAt: new Date().toISOString(),
    assignmentId: createId(`assignment_${RISK_PLAN_EXPERIMENT_KEY}_treatment_main`),
  });

  writeStoredAssignment(created);
  return created;
}

export function experimentContextFields(assignment) {
  if (!assignment) {
    return {};
  }

  return {
    experiment_key: assignment.experiment_key,
    experiment_variant: assignment.experiment_variant,
    assigned_visual_funnel: assignment.assigned_visual_funnel,
    assignment_id: assignment.assignment_id,
    assignment_source: assignment.assignment_source,
    assignment_created_at: assignment.assignment_created_at,
  };
}
